import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Row, UIText2 } from '@cian/ui-kit';
import { QuestionLayoutBodyWrapper } from '../QuestionLayoutBodyWrapper';
import * as styles from './QuestionLayoutBody.css';
import { QuestionFieldWrapper } from '../QuestionFieldWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuestionLayoutBody = function QuestionLayoutBody(props) {
  var helpLinks = props.helpLinks,
    question = props.question,
    error = props.error,
    fieldMapper = props.fieldMapper,
    bottomBanner = props.bottomBanner,
    topBanner = props.topBanner,
    layoutType = props.layoutType;
  var key = React.useMemo(function () {
    return "body".concat(topBanner || bottomBanner ? 'WithBanner' : '');
  }, [bottomBanner, topBanner]);
  return /*#__PURE__*/_jsxs(QuestionLayoutBodyWrapper, {
    layoutType: layoutType,
    children: [helpLinks, topBanner, /*#__PURE__*/_jsx(Row, {
      children: question.fields.map(function (field) {
        var FieldComponent = fieldMapper(field.type);
        return /*#__PURE__*/_jsx(QuestionFieldWrapper, {
          field: field,
          children: /*#__PURE__*/_jsx(FieldComponent, _objectSpread({}, field))
        }, field.name);
      })
    }), bottomBanner, error && /*#__PURE__*/_jsx("div", {
      className: styles['error'],
      "data-testid": "error",
      children: /*#__PURE__*/_jsx(UIText2, {
        color: "error_100",
        children: error
      })
    })]
  }, key);
};